import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Shown for every /citizen/* route while the `citizen_enabled` flag is off.
 *
 * Intentionally free of any `src/citizen` import so the dark path does not pull
 * in the citizen theme or shell.
 */
const CitizenComingSoonPage: React.FC = () => (
  <div className="min-h-screen flex items-center justify-center bg-background dark:bg-background-dark-primary px-6">
    <div className="max-w-md text-center">
      <h1 className="text-3xl font-semibold text-neutral-900 dark:text-text-dark-primary">
        Coming soon
      </h1>
      <p className="mt-4 text-neutral-600 dark:text-text-dark-tertiary">
        The Capitol Commons citizen experience is on its way. Check back shortly.
      </p>
      <Link
        to="/"
        className="mt-8 inline-block rounded-md bg-primary px-5 py-2.5 text-white hover:opacity-90"
      >
        Back to Capitol Commons
      </Link>
    </div>
  </div>
);

export default CitizenComingSoonPage;
